// Trip risk classification + per-trip Duty of Care record helpers.
// Risk level is derived from the destination string by matching country names.

export const HIGH_RISK_COUNTRIES = [
  'Afghanistan', 'Belarus', 'Burma', 'Myanmar', 'Central African Republic',
  'Haiti', 'Iran', 'Iraq', 'Libya', 'Mali', 'North Korea', 'Russia',
  'Somalia', 'South Sudan', 'Sudan', 'Syria', 'Ukraine', 'Venezuela', 'Yemen',
];

export const MEDIUM_RISK_COUNTRIES = [
  'Egypt', 'Turkey', 'Mexico', 'India', 'Kenya', 'Nigeria', 'Colombia',
  'Pakistan', 'Lebanon', 'Israel', 'Saudi Arabia', 'Algeria', 'Ethiopia',
  'Honduras', 'Guatemala', 'Philippines', 'Indonesia', 'Brazil',
];

export const RISK_META = {
  high: { label: 'High risk', color: '#ef4444' },
  medium: { label: 'Medium risk', color: '#f59e0b' },
  low: { label: 'Low risk', color: '#10b981' },
};

export function tripRiskLevel(destination = '') {
  const d = String(destination).toLowerCase();
  if (HIGH_RISK_COUNTRIES.some((c) => d.includes(c.toLowerCase()))) return 'high';
  if (MEDIUM_RISK_COUNTRIES.some((c) => d.includes(c.toLowerCase()))) return 'medium';
  return 'low';
}

// Match a trip's traveller (a name string) to an employee record by full name.
export function matchTraveller(trip, employees = []) {
  const name = String(trip.employee || '').trim().toLowerCase();
  if (!name) return null;
  return (
    employees.find(
      (e) => `${e.firstName || ''} ${e.lastName || ''}`.trim().toLowerCase() === name,
    ) || null
  );
}
